import { useState } from 'react';
import styled from 'styled-components';
import { MozartModal, MozartButton } from '@pgforsta/mozart_ui/lib/v4';
import ModalWrapper from '../styled/ModalWrapper';
import ButtonGroup from '../styled/ButtonGroup';
import { deleteSources } from '../../api/services/sources';
import useAsync from '../../hooks/async';

const ConfirmationQuestion = styled.p`
  margin-bottom: 15px;
`;

const DeleteModal = ({ harvesterIds, onConfirm, onCancel }) => {
  const query = useAsync();
  const [confirmation, setConfirmation] = useState(false);

  const handleConfirmation = () => {
    setConfirmation(true);
    query.run(deleteSources(harvesterIds));
  };

  const renderModalContents = () => {
    if (!confirmation) {
      const question =
        harvesterIds.length > 1
          ? `Do you want to delete ${harvesterIds.length} URLs?`
          : 'Do you want to delete the URL?';
      return (
        <>
          <ConfirmationQuestion>{question}</ConfirmationQuestion>
          <ButtonGroup>
            <MozartButton outline onClick={onCancel}>
              No
            </MozartButton>
            <MozartButton onClick={handleConfirmation}>Yes</MozartButton>
          </ButtonGroup>
        </>
      );
    }

    if (query.isIdle || query.isPending) {
      return <p>Loading...</p>;
    }

    if (query.isRejected) {
      return (
        <p>
          There was an error deleting the URL
          {harvesterIds.length > 1 ? 's' : ''}
        </p>
      );
    }

    return <p>URL deletion initiated!</p>;
  };

  return (
    <ModalWrapper>
      <MozartModal
        show={harvesterIds.length > 0}
        onClose={() => (confirmation ? onConfirm() : onCancel())}
        title={`Delete URL${harvesterIds.length > 1 ? 's' : ''}`}
        size="medium"
      >
        {renderModalContents()}
      </MozartModal>
    </ModalWrapper>
  );
};

export default DeleteModal;
